module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("store_gallery_container", [["div",{"class":"block-with-label"},[["div",{"id":"gallery-cut","class":"photos-list"}],["div",{"id":"gallery-all"}],["a",{"class":"label vis","id":"show-all-photos"},[["textNode",{"text":"Show all photos"}]]]]]]);
fox.registerTemplate("store_unpurchased_gallery", [["div",{"class":"photos-cover"},[["if",{"notempty":"","addclass":"wide"},[],[["content._resources.primary.info","notempty",true,[{"name":"isWide","params":[]}]]]],["img",{"class":"photoset-cover left","src":"","alt":""},[],[["content._resources.primary.url","src",true],["title","alt",true]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/gallery/storegalleryTemplates.tpl
// module id = 1095
// module chunks = 4